import { ReactNode, useState } from "react";
import ModalPageHeader from "../../../global-layout/modal-page-header";
import ModalPageWrapper from "../../../global-layout/modal-page-wrapper";
import ResponseSettingsForm from "../response-settings-form";
import ResponseValueForm from "../response-value-form";
import { useTranslation } from "react-i18next";

interface Item {
  id: string;
  order: number;
  label: string;
  icon: ReactNode;
}
function ResponseSettings({
  selectedScreen,
  handleClose,
  responseSettingsType,
  handleImport,
  handleReponseSettingsSubmit,
  selectedResponseValue,
  responseValueOptions,
  selectedResponseItem,
  selectedChoice,
  responseMultipleChoiceOptions,
  responseDateTimeOptions,
  responseScannerOptions,
  responseImageOptions,
  responseTextOptions,
  responseMagicContainerOptions,
  handleSaveResponse,
  passUpdatedResponseval,
  bindingoptions,
  multipleOptionValidation,
}: any) {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState<string>("settings");

  return (
    <ModalPageWrapper>
      <div className="w-[50%] h-full bg-io-white dark:bg-io-black-15 ml-auto max-md:w-[85%]">
        <div className="w-full h-full">
          <div className="w-full h-full flex flex-col">
            {" "}
            <ModalPageHeader
              title={t("web.common.responsesettings")}
              handleClose={handleClose}
            />
            <div className="w-full h-full flex-auto">
              <div className="w-full h-full pl-[4.7rem] pt-[3.7rem] pr-4">
                <ResponseSettingsForm
                  selectedScreen={selectedScreen}
                  responseSettingsType={responseSettingsType}
                  handleReponseSettingsSubmit={handleReponseSettingsSubmit}
                  handleFormCancel={handleClose}
                  selectedResponseItem={selectedResponseItem}
                  selectedChoice={selectedChoice}
                  responseMultipleChoiceOptions={responseMultipleChoiceOptions}
                  responseDateTimeOptions={responseDateTimeOptions}
                  responseScannerOptions={responseScannerOptions}
                  responseImageOptions={responseImageOptions}
                  responseTextOptions={responseTextOptions}
                  responseMagicContainerOptions={responseMagicContainerOptions}
                  handleSaveResponse={(data: any) => handleSaveResponse(data)}
                  bindingoptions={bindingoptions}
                  handleImport={handleImport}
                  selectedResponseValue={selectedResponseValue}
                  responseValueOptions={responseValueOptions}
                  passUpdatedResponseval={passUpdatedResponseval}
                  multipleOptionValidation={multipleOptionValidation}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalPageWrapper>
  );
}
export default ResponseSettings;
